import * as actionTypes from '../../../constants/ActionTypes/Web/Customer/SignUp';

const initialState = {
    'success': false,
    'loading': false,
    'error': false,
    'data': {}
}

const GetPromotionBannerStatus = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.GET_PROMOTION_BANNER_STATUS:
            return {
                ...state,
                loading: true,
                'success': false,
                'error': false,
                'data': {}
            }
        case actionTypes.GET_PROMOTION_BANNER_STATUS_SUCCESS:
            return {
                ...state,
                success: true,
                loading: false,
                data: action.promotionBannerStatus,
                'error': false
            }
        case actionTypes.GET_PROMOTION_BANNER_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.message,
            }
        default:
            return {...state};
    }
}

export default GetPromotionBannerStatus;